module.exports = __webpack_public_path__ + "images/2044502.png";